declare const videojs: any;

export const videoJs = videojs;
